import { Appearance } from '@stripe/stripe-js';

/**
 * Google Fonts source for Montserrat, handed to Stripe Elements so the (sandboxed) Stripe iframe can
 * render the same typeface as the rest of the app — Stripe can't see the host page's `@font-face`
 * rules, so the font must be declared on the Elements group explicitly. Same URL the app imports in
 * `_theme.scss`.
 */
export const STRIPE_FONT_SRC = 'https://fonts.googleapis.com/css?family=Montserrat:300,400,500';

/**
 * Stripe Elements Appearance — drives the look of the native elements entirely through Stripe's
 * theming API rather than our own CSS, keyed off the Octiga brand tokens (`--primary-color`
 * `#009af8`, Montserrat). Shared by every Stripe Elements surface (trial signup, card update) so
 * they all read as one Stripe-styled surface.
 */
export const STRIPE_APPEARANCE: Appearance = {
    theme: 'stripe',
    variables: {
        colorPrimary: '#009af8',
        colorText: '#2c2c2c',
        colorDanger: '#e53935',
        fontFamily: 'Montserrat, sans-serif',
        fontSizeBase: '14px',
        borderRadius: '6px',
        spacingUnit: '4px',
    },
    rules: {
        '.Input': {
            border: '1px solid #d0d5dd',
            boxShadow: 'none',
            padding: '10px 12px',
        },
        '.Input:focus': {
            border: '1px solid #009af8',
            boxShadow: '0 0 0 1px #009af8',
        },
        '.Label': {
            fontWeight: '500',
            color: '#52525b',
        },
    },
};
